import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
    {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/category',
    name: 'Category',
    component: () => import('../views/category.vue')
  },
  {
    path: '/categoryMore',
    name: 'CategoryMore',
    component: () => import('../views/categoryMore.vue')
  },
  {
    path: '/article',
    name: 'Article',
    component: () => import('../views/article.vue')
  },
  {
    path: '/videoSpecial',
    name: 'VideoSpecial',
    component: () => import('../views/videoSpecial.vue')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/search.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 在路由切换时全局控制下拉菜单显示，防止跳转后仍显示
router.beforeEach((to, from, next) => {
  try {
    document && document.body && document.body.classList.add('navigating')
  } catch (e) { void e }
  next()
})

router.afterEach((to) => {
  // 微延迟，待新页面挂载完成再移除
  setTimeout(() => {
    try {
      document && document.body && document.body.classList.remove('navigating')
    } catch (e) { void e }
  }, 300)
  
  // 只有在跳转到 article 和 home 页面时才滚动到页面顶部
  if (to.name === 'Article' || to.name === 'Home') {
    try {
      window.scrollTo(0, 0)
    } catch (e) { void e }
  }
})

export default router
